import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import networkApi from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";
import { chunkData } from "../../samples/components/report_summary/hooks";
import { NetworkRepEntry } from "../@types/Url";

const DEFAULT_QUERY_KEY_ID = "bulkNetworkReputation";
const NETWORK_REPUTATION_CHUNK_SIZE = 100;

type UseBulkNetworkReputationOptions = {
  queryKeyId?: string;
};

const useBulkNetworkReputation = (
  urls: string[],
  options?: UseBulkNetworkReputationOptions
) => {
  const chunkedData = useMemo(
    () => chunkData<string>(urls, NETWORK_REPUTATION_CHUNK_SIZE),
    [urls]
  );

  const result = useQueries({
    queries: chunkedData.map((chunk, index) => ({
      queryKey: [options?.queryKeyId || DEFAULT_QUERY_KEY_ID, chunk],
      queryFn: () => networkApi.urlReputation(chunk).then(resp => resp.data),
      onError: (error: unknown) => {
        console.error(
          `Error sending network reputation chunk ${index}:`,
          error
        );
      },
      enabled: Boolean(chunk),
      ...USEQUERY_DISABLE_REFETCH_OPTIONS
    }))
  });

  const isLoading = result.some(query => query.isLoading);

  return {
    data: result.flatMap(res => res?.data?.entries ?? []) as NetworkRepEntry[],
    notFoundLocations: result.flatMap(
      res => res?.data?.invalid_network_locations ?? []
    ),
    isLoading
  };
};

export default useBulkNetworkReputation;
